import { DateTime, Interval } from 'luxon';
import { StoredAbsenceSummary } from '../types/documents/DataTypes/AttendanceStatementData';

const toInterval = (dateFrom: string, dateTo: string): Interval | null => {
    const start = DateTime.fromISO(dateFrom).startOf('day');
    const end = DateTime.fromISO(dateTo).endOf('day');
    return start.isValid && end.isValid ? Interval.fromDateTimes(start, end) : null;
};

export function findOverlappingAbsences(
    existing: StoredAbsenceSummary[] | undefined,
    candidate: { dateFrom: string; dateTo: string },
    excludeId?: string | number
): StoredAbsenceSummary[] {
    if (!existing?.length) return [];
    const candidateInterval = toInterval(candidate.dateFrom, candidate.dateTo);
    if (!candidateInterval) return [];
    return existing.filter((a) => a.id !== excludeId && (toInterval(a.dateFrom, a.dateTo)?.overlaps(candidateInterval) ?? false));
}
